import React from 'react';

export default function MagneticButton({ children, className = '', as = 'button', ...props }) {
  const Tag = as === 'div' ? 'div' : as === 'a' ? 'a' : 'button';
  return (
    <Tag className={className} {...props}>
      {children}
    </Tag>
  );
}
